export default __webpack_public_path__ + "static/media/ecoedil.d3b2d292.png";